<template>
    <div>
        <h2>分享中间页</h2>
    </div>
</template>
<script>
export default {
    data () {
        return {
            id: '',
            url: ''
        }
    },
    created () {
        this.id = location.hash.split('/')[2]
        console.log("id:", location.hash, location.hash.split('/')[2])

        this.getWxInfo()
    },
    methods: {
        async getWxInfo () {
            const { data } = await this.$axios.post('wechat/board/share', {
                id: this.id
            })
            if (data.errCode === 0) {
                console.log(data.data.url)
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/view/share/BoardShare.vue